var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollumnsWhiteOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.6 17C7.26863 17 7 16.4945 7 15.871L7 4.12903C7 3.50549 7.26863 3 7.6 3C7.93137 3 8.2 3.50549 8.2 4.12903L8.2 15.871C8.2 16.4945 7.93137 17 7.6 17ZM10 17C9.66863 17 9.4 16.4945 9.4 15.871L9.4 4.12903C9.4 3.50549 9.66863 3 10 3C10.3314 3 10.6 3.50549 10.6 4.12903L10.6 15.871C10.6 16.4945 10.3314 17 10 17ZM12.4 17C12.0686 17 11.8 16.4945 11.8 15.871L11.8 4.12903C11.8 3.50549 12.0686 3 12.4 3C12.7314 3 13 3.50549 13 4.12903L13 15.871C13 16.4945 12.7314 17 12.4 17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollumnsWhiteOutline);
export default __webpack_public_path__ + "static/media/collumnsWhiteOutline.84a43440e3035f87ec449e64c670c85c.svg";
export { ForwardRef as ReactComponent };